<template>
  <div id="app">
    <HeaderBar/>
    <div class="columns is-gapless">
    <div class="column is-narrow is-hidden-mobile has-background-black-ter">
      <SideBar/>
    </div>
    <div class="column">
      <router-view/>
    </div>
  </div>
  </div>
</template>

<style lang="scss">
// サイドメニューの色設定
$menu-item-active-background-color: hsl(171, 100%, 41%);
$menu-item-color: hsl(0, 0%, 100%);

@import "../node_modules/bulma/bulma.sass";
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';
</style>

<script>
import HeaderBar from '@/components/HeaderBar.vue'
import SideBar from '@/components/SideBar.vue'

export default {
  name: 'app',
  components: {
    HeaderBar,
    SideBar
  }
}
</script>